<script setup lang="ts">
import FormDescription from '@satch-ui/primitives/form/FormDescription.vue'
import FormItem from '@satch-ui/primitives/form/FormItem.vue'
import { Slider } from '@satch-ui/primitives/slider'
import { formatPrice } from 'internal/format-price'

import {
  FormControl,
  FormField,
  FormMessage,
  type FormSliderProps,
} from '@fond-of/fondof-ui'

const props = defineProps<FormSliderProps>()
</script>

<template>
  <FormField
    v-slot="{ componentField, value }"
    :name="`[${props.name}]`"
  >
    <FormItem>
      <FormControl>
        <Slider
          v-bind="componentField"
          class="min-w-[220px]"
          :min="props.min"
          :max="props.max"
          :step="1"
          :min-steps-between-thumbs="1"
        />
        <FormDescription
          class="text-primary mb-4 flex flex-wrap justify-between pt-6 font-sans"
        >
          <span
            v-for="val in value"
            :key="val"
          >
            {{
              formatPrice(val * 100, 'EUR', {
                maximumFractionDigits: 0,
              })
            }}
          </span>
        </FormDescription>
      </FormControl>
      <FormMessage class="text-red text-xs" />
    </FormItem>
  </FormField>
</template>
